/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsActivatePostRequest model module.
 * @module model/CustomersSubscriptionsActivatePostRequest
 * @version 1.0.0
 */
class CustomersSubscriptionsActivatePostRequest {
    /**
     * Constructs a new <code>CustomersSubscriptionsActivatePostRequest</code>.
     * @alias module:model/CustomersSubscriptionsActivatePostRequest
     * @param email {String} 
     */
    constructor(email) { 
        
        CustomersSubscriptionsActivatePostRequest.initialize(this, email);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email) { 
        obj['email'] = email;
    }

    /**
     * Constructs a <code>CustomersSubscriptionsActivatePostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsActivatePostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsActivatePostRequest} The populated <code>CustomersSubscriptionsActivatePostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsActivatePostRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsActivatePostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsActivatePostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersSubscriptionsActivatePostRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

CustomersSubscriptionsActivatePostRequest.RequiredProperties = ["email"];

/**
 * @member {String} email
 */
CustomersSubscriptionsActivatePostRequest.prototype['email'] = undefined;






export default CustomersSubscriptionsActivatePostRequest;

